export default __webpack_public_path__ + "6e8b21cfc064bdd002b7f0a8eaec5c02.png";